import React, { useMemo } from 'react'
import { SkeletonForm } from '@node-space/storybook-components/dist/SkeletonLoader'
import { useVerticalContext } from 'hooks/context/useVerticalContext'
import { FormGetError } from 'pages/Verification/_components/FormGetError'
import { ConfirmIndustryPrompt } from '../../../../components/ConfirmIndustryPrompt'
import { UploadDocumentsForm } from './components/UploadDocumentsForm'
import { useUploadDocuments } from './helpers/useUploadDocuments'

export const UploadDocuments = () => {
  const { isIndustryConfirmed } = useVerticalContext()
  const { isFetchingRequiredDocuments, isErrorFetchingRequiredDocuments, formData } =
    useUploadDocuments()

  const isLoading = useMemo(
    () => isIndustryConfirmed && isFetchingRequiredDocuments,
    [isIndustryConfirmed, isFetchingRequiredDocuments]
  )

  return isLoading ? (
    <SkeletonForm name="Upload documents" />
  ) : isErrorFetchingRequiredDocuments ? (
    <FormGetError />
  ) : isIndustryConfirmed ? (
    <UploadDocumentsForm {...formData} />
  ) : (
    <ConfirmIndustryPrompt />
  )
}
